import { render, staticRenderFns } from "./FootballStatics.vue?vue&type=template&id=a4cc2768&scoped=true&"
import script from "./FootballStatics.vue?vue&type=script&lang=js&"
export * from "./FootballStatics.vue?vue&type=script&lang=js&"
import style0 from "./FootballStatics.vue?vue&type=style&index=0&id=a4cc2768&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cc2768",
  null
  
)

export default component.exports